/*eslint-disable*/
import Autosuggest from "react-autosuggest";
import React from "react";
import store from "store";
import './Autofill.css'

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : store
        .getState()
        .occupations.occupations.filter(occ =>
          occ.name.toLowerCase().includes(inputValue)
        );
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => <div>{suggestion.name}</div>;

class Autofill extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      suggestions: []
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });

    this.props.input.onChange(newValue);
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  isrequired(id) {
    return this.props.isrequired;
  }
  render() {
    if (this.props.meta.pristine) {
      this.props.meta.valid = false;
    }

    if (this.isrequired(this.props.input.isrequired) == false) {
      this.props.meta.valid = true;
    }

    const { value, suggestions } = this.state;

    let trySubmit = this.props.checkValidation ? true: false;
        
    const { meta: { touched, error, warning } } = this.props;
    let lValue = this.props.input.value;

    const inputProps = {
      placeholder: "Type an occupation",
      value:lValue,
      onChange: this.onChange
    };

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(
            this
          )}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        />
      </div>
      
    );
  }
}

export default Autofill;



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/Autofill.js